__turbopack_context__.v({
  "closeBtn": "_1X04gW_closeBtn",
  "headline": "_1X04gW_headline",
  "shareDialog": "_1X04gW_shareDialog",
});
